import { AfterViewInit, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AMBIENTE, USA_BETO, USA_PROMOCIONAL, USA_TURISMO, USA_RODOVIARIO } from '../app.config';
import { Usuario } from '../model';
import { LoginService, UsuarioService } from '../services';
import {
    MENU_AGENCIA,
    MENU_CADASTRO,
    MENU_EVENTOS,
    MENU_FINANCEIRO,
    MENU_GERENCIAMENTO,
    MENU_GESTAO_FORNECEDORES,
    MENU_GESTAO_RESERVAS,
    MENU_GRUPOS_CASAMENTOS,
    MENU_INTRANET,
    MENU_MINHA_AGENCIA,
    MENU_USA_TURISMO
} from "./pages-menu";

@Component({
    selector: 'ngx-pages',
    styleUrls: ['pages.component.scss'],
    templateUrl: './pages.component.html',
})

export class PagesComponent implements OnInit, AfterViewInit {

    usuario: Usuario;
    menu = [];
    private permissoes = [];
    private perfis = [];

    constructor(
        private loginService: LoginService,
        private usuarioService: UsuarioService,
        private translate: TranslateService
    ) {
    };

    ngAfterViewInit() {
    }

    isRoot = false;
    isAdmin = false;
    private usaBeto = USA_BETO;

    MENU_TURISMO = MENU_USA_TURISMO;
    MENU_CADASTRO = MENU_CADASTRO;
    MENU_GRUPOS_CASAMENTOS = MENU_GRUPOS_CASAMENTOS;
    MENUEVENTOS = MENU_EVENTOS;

    // MENU_SUPORTE = MENU_SUPORTE;

    ngOnInit() {
        if (AMBIENTE != "FRT" && AMBIENTE != "HOMOLOGA" && AMBIENTE != "") {
            this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title != "Pronta Referência");
            this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Suporte");
            this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title != "FRT Cruzeiros");
            this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title != "Oportunidades Aéreo");
            this.MENU_GRUPOS_CASAMENTOS = this.MENU_GRUPOS_CASAMENTOS.filter(x => x.title != "Grupos / Casamentos");
            this.MENUEVENTOS = this.MENUEVENTOS.filter(x => x.title !== "Notificações")

        }
        if (AMBIENTE !== "HOMOLOGA") {
            this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "+FRT");
        }

        if (AMBIENTE != "FRT-PY") {
            this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title != "Black November");
        }

        if (!this.usaBeto) {
            this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Beto Carrero");
        }

        if (!USA_PROMOCIONAL) {
            this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Serviços pelo Mundo");
        }

        if(!USA_RODOVIARIO) {
            this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Rodoviário");
            this.MENU_CADASTRO = this.MENU_CADASTRO.filter(x => x.children = x.children.filter(c => c.title !== "Rodoviário"));
        } else {
            this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Roteiros");
        }

        //filtrar por ambientes
        switch (AMBIENTE) {
            case "FRT":
                this.MENU_CADASTRO = this.MENU_CADASTRO.filter(x => x.children = x.children.filter(c => c.title !== "Carro Offline"));
                this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Disney");
                break;
            case "RECEPTIVO":
            case "GENIUS":
            case "AGENTGO":
                this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Campanha");
                this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Roteiros");
                this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Bloqueios");
                this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Disney");

                break;
            case "ARKBEDS":
                this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Campanha");
                this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Bloqueios");
                this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Disney");
                break;
            case "FRT-PY":
                this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Campanha");
                this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Disney");
                break;
            case "AGENTETUR":
                this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Roteiros");
                this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Bloqueios");
                break;
            case "FNV":
                this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Disney");
                this.MENU_TURISMO = this.MENU_TURISMO.filter(x => x.title !== "Campanha");

                break;
        }

        const permi = window.localStorage.getItem('gy84d8');
        const perfi = window.localStorage.getItem('a5s74');
        this.usuario = this.loginService.user();

        if (permi != null && perfi != null) {

            this.permissoes = JSON.parse(atob(permi));

            this.perfis = JSON.parse(atob(perfi));
            if (this.possuiPermissao(["root"])) this.isRoot = true;
            if (this.possuiPermissao(["admin"])) this.isAdmin = true;
            setTimeout(() => this.montaMenu(), 1500);
        } else {
            setTimeout(() => this.buscarPermissoes(), 300)
        }
    }

    private buscarPermissoes() {
        this.usuarioService.buscarMinhasPermissoes().subscribe(
            dados => {
                this.permissoes = dados.filter(x => x.Tipo === 'permissao').map(x => x.Permissao);
                this.perfis = dados.filter(x => x.Tipo === 'perfil').map(x => x.Permissao);

                if (this.usuario && this.usuario.AgenteAdmin) {
                    this.permissoes.push('agenteadmin');
                }

                window.localStorage.setItem('gy84d8', btoa(JSON.stringify(this.permissoes)));
                window.localStorage.setItem('a5s74', btoa(JSON.stringify(this.perfis)));

                if (this.permissoes.length > 0) {
                    if (this.possuiPermissao(["root"])) this.isRoot = true;
                    if (this.possuiPermissao(["admin"])) this.isAdmin = true;
                    this.montaMenu();
                } else
                    setTimeout(() => this.buscarPermissoes(), 300);

            }, erros => {
                console.log('Erro ao buscar permissoes');
                console.log(erros);
                setTimeout(() => {
                    this.buscarPermissoes();
                }, 1500);
            },
        );
    }

    private montaMenu() {
        let item;

        if (USA_TURISMO) {
            item = this.filtraMenu(this.MENU_TURISMO);
            this.menu = [...this.menu, ...item];
        }

        item = this.filtraMenu(MENU_AGENCIA);
        this.menu = [...this.menu, ...item];

        item = this.filtraMenu(MENU_MINHA_AGENCIA);
        this.menu = [...this.menu, ...item];

        item = this.filtraMenu(MENU_FINANCEIRO);
        this.menu = [...this.menu, ...item];

        item = this.filtraMenu(this.MENU_CADASTRO);
        this.menu = [...this.menu, ...item];

        item = this.filtraMenu(MENU_GERENCIAMENTO);
        this.menu = [...this.menu, ...item];

        item = this.filtraMenu(MENU_GESTAO_RESERVAS);
        this.menu = [...this.menu, ...item];

        if (this.permissoes.indexOf("nao_visualiza_faturas") > -1) {
            const financeiroMenu = this.menu.find(x => x.title === "Financeiro");
            if (financeiroMenu) {
                financeiroMenu.children = financeiroMenu.children.filter(x => x.title !== "Faturas");
            }
        }

        // Se não for "RECEPTIVO" ou se for "", adiciona esses itens
        if (AMBIENTE !== "RECEPTIVO") {
            item = this.filtraMenu(this.MENU_GRUPOS_CASAMENTOS);
            this.menu = [...this.menu, ...item];

            item = this.filtraMenu(MENU_INTRANET);
            this.menu = [...this.menu, ...item];
        }

        // Adiciona todos os itens sem restrição se o ambiente for uma string vazia
        if (AMBIENTE === "" || AMBIENTE === "FRT" || AMBIENTE === "HOMOLOGA") {
            item = this.filtraMenu(MENU_EVENTOS);
            this.menu = [...this.menu, ...item];
        }

        item = this.filtraMenu(MENU_GESTAO_FORNECEDORES);
        this.menu = [...this.menu, ...item];

        // Traduzindo os títulos do menu
        this.menu = this.menu.map(x => {
            x.title = this.translate.instant(x.title);
            return x;
        });

        // Traduzindo os títulos dos submenus
        this.menu.filter(x => x.children)
            .map(x => x.children).flat().map(y => {
                y.title = this.translate.instant(y.title);
                return y;
            });
    }


    private filtraMenu(menu) {

        return menu.filter(x => {
            if (x.children && x.children.length > 0) {
                x.children = x.children.filter(c => this.possuiPermissao(c.permissoes))
            }
            return this.possuiPermissao(x.permissoes);
        });

    }

    private possuiPermissao(permissoes): boolean {

        return (
            !permissoes ||
            permissoes.length == 0 ||
            this.isRoot ||
            this.isAdmin ||
            permissoes.some((permissao, indice, array) => {
                return (
                    this.permissoes.map((x) => x.toLowerCase()).indexOf(permissao) > -1
                );
            })
        );
        // return (this.permissoes.map(x => x.toLowerCase() ).indexOf(permissao) > -1);
    }
}
